const statementIdRegExp = /(\d{4})([1234]{1})\w$/;

/**
 * A statement ID looks like: "1601575683AS0006468120193A"
 * The last five numbers form a year / quarter, i.e. "20193" for the above id, which represents
 * year 2019, quarter 3.
 *
 * Example:
 *
 * The statementId: "1601575683AS0006468120193A" would return:
 *
 * {
 *      year: 2019,
 *      quarter: 3,
 * }
 * @param statementId - a string that is expected to be a statement ID
 * @return - a {@link YearAndQuarter} object representing the statement period, or null if none
 * could be parsed from the input
 */
export const parseStatementIdAsYearAndQuarter = (
    statementId: string,
): Maybe<YearAndQuarter> => {
    let year = 0;
    let quarter = 0;

    const match = statementId.match(statementIdRegExp);

    if (match === null) {
        return null;
    }

    const yearString = match[1];
    const quarterString = match[2];

    try {
        year = parseInt(yearString, 10);

        quarter = parseInt(quarterString, 10);

        if (Number.isNaN(year) || Number.isNaN(quarter)) {
            return null;
        }

        return {
            year,
            quarter,
        };
    } catch {
        return null;
    }
};
